#import "../fragments/EmailBlockFields.graphql"

mutation UpdateEmailTemplate($id: ID!, $input: EmailTemplateInput!) {
  updateEmailTemplate(id: $id, input: $input) {
    id
    name
    updatedAt
    variants {
      language
      subject
      preheader
      blocks {
        ...EmailBlockFields
      }
    }
  }
}
